

export const md5 = (string) =>  {
  const md5Package = require(/* webpackChunkName: "md5" */ 'md5');
  return md5Package(string)
};

/**
 * Simple object check.
 * @param item
 * @returns {boolean}
 */
export const isObject = (item) => {
  return (item && typeof item === 'object' && !Array.isArray(item));
};


 /**
 * Deep merge two objects.
 * @param target
 * @param ...sources
 */
export const deepMerge = (target, ...sources) => {
  if (!sources.length) return target;
  const source = sources.shift();

  if (isObject(target) && isObject(source)) {
    for (const key in source) {
      if (isObject(source[key])) {
        if (!target[key]) Object.assign(target, { [key]: {} });
        deepMerge(target[key], source[key]);
      } else {
        Object.assign(target, { [key]: source[key] });
      }
    }
  }

  return deepMerge(target, ...sources);
};
/**
 * Encodes a utf8 string to Base64
 * @param { string } str - The string to be encoded.
 */
export const encodeBase64 = (str) => {
  return window.btoa(unescape(encodeURIComponent(str)));
};

/**
 * Decodes a Base64 string to utf8
 * @param { string } str - The string to be decoded.
 */
export const decodeBase64 = (str) => {
  if (str === null) {
    return "";
  }
  return decodeURIComponent(escape(window.atob(str)));
};

/**
 * Convert a base64 string to a file
 * @param {*} base64String 
 * @param {*} filename 
 * @param {*} mimeType 
 * @returns 
 */
export const base64ToFile = (base64String, filename, mimeType) => {
  // Convert base64 to raw binary data held in a string
  const byteString = atob(base64String.split(',')[1]);

  // Separate out the mime component
  const mimeString = base64String.split(',')[0].split(':')[1].split(';')[0];

  // Write the bytes of the string to an ArrayBuffer
  const arrayBuffer = new ArrayBuffer(byteString.length);
  const uintArray = new Uint8Array(arrayBuffer);
  for (let i = 0; i < byteString.length; i++) {
    uintArray[i] = byteString.charCodeAt(i);
  }

  // Create a Blob from the ArrayBuffer
  const blob = new Blob([arrayBuffer], {type: mimeType || mimeString});

  // Create a File from the Blob
  const file = new File([blob], filename, {type: mimeType || mimeString});

  return file;
}

/**
 * Split an array in to chunks of a specific size.
 * @param {array} array - abritrary array
 * @param {integer} chunkSize - the size of the chunks to create.
 */
export const chunkArray = (array, chunkSize = 10) => {

  const chunks = [];

  for (let i = 0; i < array.length; i += chunkSize) {
    const chunk = array.slice(i, i + chunkSize);
    chunks.push(chunk);
  }

  return chunks;

};

/**
 * Serialize a javascript object for a url
 */
export const serialize = (obj, prefix) => {
  var str = [],
    p;
  for (p in obj) {
    if (obj.hasOwnProperty(p)) {
      var k = prefix ? prefix + "[" + p + "]" : p,
        v = obj[p];
      str.push((v !== null && typeof v === "object") ?
        serialize(v, k) :
        encodeURIComponent(k) + "=" + encodeURIComponent(v));
    }
  }
  return str.join("&");
}

/**
 * basic debounce function
 * @param {*} func
 * @param {*} wait
 * @returns
 */
// export const debounce = (func, wait) => {
//   window.reactDebounceTimeout = null;
//   return function (...args) {
//     const context = this;
//     if (window.reactDebounceTimeout) clearTimeout(window.reactDebounceTimeout);
//     window.reactDebounceTimeout = setTimeout(() => {
//       window.reactDebounceTimeout = null;
//       func.apply(context, args);
//     }, wait);
//   };
// }

/**
 * A functional debouncer that works with React, by settings some values to the window.
 * @param {*} func
 * @param {*} wait
 * @returns
 */
export const debounce = (func, wait, immediate) => {
  window.reactDebounceTimeout = null;
  return function() {
    var context = this, args = arguments;
    var later = function() {
      window.reactDebounceTimeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !window.reactDebounceTimeout;
    clearTimeout(window.reactDebounceTimeout);
    window.reactDebounceTimeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};

export const stripHtml = (html) => {

  let tmp = document.createElement("DIV");
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || "";

}

export const decodeHtml = (str) => {

  var map = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'",
    '&#039;': "'"
  };

  if (typeof(str) == 'undefined') {
    return "";
  }

  return str.replace(/&amp;|&lt;|&gt;|&quot;|&#39;|&#039;/g, function(m) {return map[m];});

}

export const getGoogleFontName = (fontFamily, spaceChar = " ")  => {

  if (!fontFamily || typeof(fontFamily) == 'undefined') {
    return "";
  }
  
  let family = fontFamily.split('-')[0].trim();
  family = family.replace(/([A-Z]+)/g, " $1").replace(/([A-Z][a-z])/g, " $1").trim();
  family = family.replaceAll(" ", spaceChar).replaceAll(`${spaceChar}${spaceChar}`, spaceChar);

  return family;

}

export const loadGoogleFont = (fontFamily, spaceChar = " ") => {

  let family = getGoogleFontName(fontFamily, spaceChar);

  let url  = `https://fonts.googleapis.com/css2?family=${family}&display=swap`;
  let link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = url;
  document.getElementsByTagName('head')[0].appendChild(link);

}

export const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

  /**
 * Converts the date to a human readable format
 * eg -> Jan. 1, 2022
 */
export const formatDate = (value) => {
  let date = new Date(value);
  date = date.toString().split(" ");
  return date[1] + ". " + date[2] + ", " + date[3];
};

/**
 * Check if a settings value is enabled.
 * @returns {Boolean}
 */
export const isEnabled = (settingsValue) => {
  return (
    settingsValue === true ||
    settingsValue === "true" ||
    settingsValue === "1" ||
    settingsValue === 1
  );
};
